import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const resourceLinks = [
    { label: t('footer_spreadsheet'), href: '/cssbuy-spreadsheet/' },
    { label: t('footer_guides'), href: '#guides' },
    { label: t('footer_reviews'), href: '/cssbuy-review/' },
    { label: t('footer_shipping'), href: '/cssbuy-shipping-cost/' },
    { label: t('footer_qc'), href: '/cssbuy-qc/' },
    { label: t('footer_warehouse_footer'), href: '/cssbuy-warehouse/' },
    { label: t('footer_safety_footer'), href: '/cssbuy-safety/' },
    { label: t('footer_faq'), href: '#faq' },
  ];

  const infoLinks = [
    { label: t('footer_about'), href: '/about/' },
    { label: t('footer_editorial'), href: '/editorial-policy/' },
    { label: t('footer_methodology'), href: '/methodology/' },
    { label: t('footer_contact_footer'), href: '/contact/' },
  ];

  const legalLinks = [
    { label: t('footer_disclaimer'), href: '/disclaimer/' },
    { label: t('footer_privacy'), href: '/privacy/' },
    { label: t('footer_terms'), href: '/terms/' },
  ];

  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <a href="/" className="text-xl font-bold text-stone-800 tracking-tight">
              CSSBuy<span className="text-emerald-600">BR</span>
            </a>
            <p className="mt-3 text-sm text-stone-500 leading-relaxed">
              {t('footer_disclaimer_text')}
            </p>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-stone-800 uppercase tracking-wider mb-4">
              {t('footer_resources')}
            </h3>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-stone-600 hover:text-emerald-700 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-sm font-semibold text-stone-800 uppercase tracking-wider mb-4">
              {t('footer_information')}
            </h3>
            <ul className="space-y-2.5">
              {infoLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-stone-600 hover:text-emerald-700 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal + Languages */}
          <div>
            <h3 className="text-sm font-semibold text-stone-800 uppercase tracking-wider mb-4">
              {t('footer_legal')}
            </h3>
            <ul className="space-y-2.5 mb-6">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-stone-600 hover:text-emerald-700 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <h3 className="text-sm font-semibold text-stone-800 uppercase tracking-wider mb-4">
              {t('footer_languages')}
            </h3>
            <div className="flex gap-3">
              <a href="/" className="text-sm text-stone-600 hover:text-emerald-700 transition-colors">{t('lang_pt')}</a>
              <a href="/de/" className="text-sm text-stone-600 hover:text-emerald-700 transition-colors">{t('lang_de')}</a>
              <a href="/en/" className="text-sm text-stone-600 hover:text-emerald-700 transition-colors">{t('lang_en')}</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-stone-200 text-center">
          <p className="text-xs text-stone-400">
            © 2026 CSSBuyBR.mom — {t('footer_disclaimer_text')}
          </p>
        </div>
      </div>
    </footer>
  );
}